import type { ReturnLabel } from '@/models/FulfillmentPrint';
import { escapeHtml } from '@/utils/escapeHtml';

/**
 * The label stock on the desk's label printer: 100x150mm fed portrait. Declared on the label's own document,
 * so it can neither inherit another sheet's page size nor impose its own on the rest of the admin [SSD-6946].
 */
export const RETURN_LABEL_PAGE = { widthMm: 100, heightMm: 150, marginMm: 5 } as const;

/** The supplier-return label as a document of its own, so the printed sticker is the preview and nothing else. */
export class ReturnLabelSheet {
  public static htmlOf(label: ReturnLabel): string {
    const { widthMm, heightMm, marginMm } = RETURN_LABEL_PAGE;
    const rows = label.lines.map((line) => `<tr><td>${escapeHtml(line)}</td></tr>`).join('');
    return `<!doctype html><html><head><meta charset="utf-8"><title>Return label</title>
    <style>
      @page { size: ${widthMm}mm ${heightMm}mm; margin: ${marginMm}mm; }
      html, body { margin: 0; padding: 0; }
      body { font-family: 'Malgun Gothic', 'Apple SD Gothic Neo', sans-serif; color: #000; background: #fff; }
      table { width: 100%; border-collapse: collapse; }
      /* A hand-typed carrier or a long product name wraps rather than running off the sticker. */
      th, td { overflow-wrap: anywhere; }
      /* A table head repeats on every sticker, so a return that runs onto a second label still names its carrier. */
      th { text-align: left; font-size: 9mm; font-weight: 800; padding: 0 0 2mm; border-bottom: 0.6mm solid #000; }
      td { font-size: 5mm; line-height: 1.35; padding: 2mm 0; border-bottom: 0.2mm solid #000; }
      tr { break-inside: avoid; }
    </style></head><body>
    <table>
      <thead><tr><th>${escapeHtml(label.carrier)}</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>
  </body></html>`;
  }
}
